export default "__VITE_ASSET__fed5550d__"